var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationTriangleSolid = function SvgExclamationTriangleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 3.219-.875 1.5-12 20.781-.844 1.5H29.72l-.844-1.5-12-20.781Zm0 4L26.25 25H5.75ZM15 14v6h2v-6Zm0 7v2h2v-2Z"
  })));
};
export default SvgExclamationTriangleSolid;